import React from 'react'
import { useDispatch } from 'react-redux'

import { changeOrderReviewStatus } from '../redux/actions'
import { Order, OrderReview as Review } from '../redux/types'

import PartnerStars from 'panel/partner/config/components/PartnerStars'

const OrderReview: React.FC<{ order: Order }> = ({ order }) => {
  const dispatch = useDispatch()
  const defaultPicture = `${process.env.PUBLIC_URL}/img/default-user.png`

  function handleUpdateReviewStatus (status: Review['status']): void {
    const { partner, review } = order
    if (partner?.id && review?.id) {
      changeOrderReviewStatus(partner.id, order.id, review.id, status)(dispatch)
    }
  }

  return (
    <div className="row margin-tb-16">
      <img
        alt="Partner"
        src={order.user.person?.picture || defaultPicture}
        style={{ width: 60, height: 60, borderRadius: '50%' }}
      />

      <div className="grow padding-left-16">
        <h3>
          { order.user.person?.name }

          <select
            style={{ position: 'absolute', right: 16, top: -8, width: 200 }}
            value={order.review?.status || 'REVIEWED'}
            onChange={(e): void => handleUpdateReviewStatus(e.target.value as 'REVIEWED')}
          >
            <option value="SKIPPED">Ignorada</option>
            <option value="REVIEWED">Pendente</option>
            <option value="APPROVED">Aprovada</option>
            <option value="REJECTED">Rejeitada</option>
          </select>
        </h3>
        <PartnerStars average={order.review?.points || 0} />

        <p>
          {
            order.review?.status === 'SKIPPED'
              ? 'O usuário ignorou a avaliação'
              : (
                order.review?.message || 'Avaliação não enviada'
              )
          }
        </p>
      </div>
    </div>
  )
}

export default OrderReview
